import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import {
  SELECT_CATEGORY,
  INVALIDATE_CATEGORY,
  REQUEST_MOVIES,
  RECEIVE_MOVIES,
  SELECT_YEAR,
  RECEIVE_MOVIES_BY_IDS,
  INVALIDATE_NEWS,
  REQUEST_NEWS,
  RECEIVE_NEWS,
  SELECT_FESTIVAL_CITY,
  INVALIDATE_FESTIVAL_CITY,
  REQUEST_FESTIVAL_CITY,
  RECEIVE_FESTIVAL_CITY,
  INVALIDATE_CITY,
  REQUEST_CITY,
  RECEIVE_CITY,
  SELECT_DAY,
  INVALIDATE_MENUS,
  REQUEST_MENUS,
  RECEIVE_MENUS,
  SELECT_MOVIE,
  REQUEST_MOVIE,
  RECEIVE_MOVIE,
  INVALIDATE_MOVIE,
  SELECT_PLAY_VIDEO,
  SELECT_CUSTOM_PAGE,
  REQUEST_CUSTOM_PAGE,
  RECEIVE_CUSTOM_PAGE,
  INVALIDATE_CUSTOM_PAGE,
  SELECT_ACTIVITY,
  REQUEST_ACTIVITY,
  RECEIVE_ACTIVITY,
  INVALIDATE_ACTIVITY,
  SELECT_QUERY,
  REQUEST_QUERY,
  RECEIVE_QUERY_RESULTS,
  INVALIDATE_QUERY,
  REQUEST_FEST_HISTORY,
  RECEIVE_FEST_HISTORY,
  SELECT_FEST_HISTORY,
  SELECT_HISTORY,
  INVALIDATE_FEST_HISTORY,
  SELECT_SECTION,
  REQUEST_SECTIONS,
  RECEIVE_SECTIONS,
  INVALIDATE_SECTIONS,
  SELECT_MOV_2_FILTER,
  REQUEST_MOV_2_FILTER,
  RECEIVE_MOV_2_FILTER,
  INVALIDATE_MOV_2_FILTER,
  SELECT_AZ,
  REQUEST_ACTIVITIES,
  RECEIVE_ACTIVITIES,
  INVALIDATE_ACTIVITIES,
  SELECT_PRESS_TYPE,
  REQUEST_PRESS,
  RECEIVE_PRESS,
  INVALIDATE_PRESS,
  SELECT_SPONSOR_MENU,
  REQUEST_SPONSOR_MENU,
  RECEIVE_SPONSOR_MENU,
  INVALIDATE_SPONSOR_MENU,
  REQUEST_SPONSOR_HOME,
  RECEIVE_SPONSOR_HOME,
  INVALIDATE_SPONSOR_HOME,
  REQUEST_POSTER,
  RECEIVE_POSTER,
  INVALIDATE_POSTER,
  SELECT_NEWS_DETAIL,
  REQUEST_NEWS_DETAIL,
  RECEIVE_NEWS_DETAIL,
  INVALIDATE_NEWS_DETAIL,
  REQUEST_TICKET,
  RECEIVE_TICKET,
  REQUEST_FEST_PROG,
  RECEIVE_FEST_PROG,
  SELECT_SCOPE,
  SELECT_AGENDACOLOR,
  SELECT_VISIBILITY,
  REQUEST_NEWSLETTER,
  RECEIVE_NEWSLETTER_ACK,
  SET_NEWSLETTER_STATUS,
  months,
  selectDay
} from "../actions/index";
import { routerReducer as router } from "react-router-redux";

function selectedScope(state = "festa", action) {
  switch (action.type) {
    case SELECT_SCOPE:
      return action.scope;
    default:
      return state;
  }
}

function selectedAgendaColor(state = "#ed162c", action) {
  switch (action.type) {
    case SELECT_AGENDACOLOR:
      return action.agenda_color;
    default:
      return state;
  }
}

function selectedVisibility(
  state = {
    festprog: "0",
    movies: "1",
    news: "0"
  },
  action
) {
  switch (action.type) {
    case SELECT_VISIBILITY:
      return action.agenda_color;
    default:
      return state;
  }
}

function selectedCategory(state = "0", action) {
  switch (action.type) {
    case SELECT_CATEGORY:
      return action.category;
    default:
      return state;
  }
}

function selectedYear(state = "2016", action) {
  switch (action.type) {
    case SELECT_YEAR:
      return action.year;
    default:
      return state;
  }
}

function selectedCity(state = "-1", action) {
  switch (action.type) {
    case SELECT_FESTIVAL_CITY:
      return action.city;
    default:
      return state;
  }
}

function selectedDay(state = "0", action) {
  switch (action.type) {
    case SELECT_DAY:
      return action.day;
    default:
      return state;
  }
}

function selectedMovie(state = "0", action) {
  switch (action.type) {
    case SELECT_MOVIE:
      return action.movie_id;
    default:
      return state;
  }
}

function selectedActivity(state = "0", action) {
  switch (action.type) {
    case SELECT_ACTIVITY:
      return action.activity_id;
    default:
      return state;
  }
}

function selectedPlayVideo(state = 0, action) {
  switch (action.type) {
    case SELECT_PLAY_VIDEO:
      return action.video_id;
    default:
      return state;
  }
}

function selectedCustomPage(state = "", action) {
  switch (action.type) {
    case SELECT_CUSTOM_PAGE:
      return action.page;
    default:
      return state;
  }
}

function showNewsLetterFrom(state = true, action) {
  switch (action.type) {
    case SET_NEWSLETTER_STATUS:
      return action.sended;
    default:
      return state;
  }
}

function selectedFestHistory(state = "", action) {
  switch (action.type) {
    case SELECT_HISTORY:
      return action.section;
    default:
      return state;
  }
}

function selectedFestHistorySubPage(state = "", action) {
  switch (action.type) {
    case SELECT_FEST_HISTORY:
      return action.section;
    default:
      return state;
  }
}

function selectedSearchQuery(state = "", action) {
  switch (action.type) {
    case SELECT_QUERY:
      return action.query;
    default:
      return state;
  }
}

function selectedSection(state = "SECÇÕES", action) {
  switch (action.type) {
    case SELECT_SECTION:
      return action.section_name;
    default:
      return state;
  }
}

function selectedMov2Filter(
  state = { mov_id: "0", mov_name: "FILMES" },
  action
) {
  switch (action.type) {
    case SELECT_MOV_2_FILTER:
      return {
        mov_id: action.mov_id,
        mov_name: action.mov_name
      };
    default:
      return state;
  }
}

function selectedAZ(state = 0, action) {
  switch (action.type) {
    case SELECT_AZ:
      return action.orderstate;
    default:
      return state;
  }
}

function selectedPress(state = "", action) {
  switch (action.type) {
    case SELECT_PRESS_TYPE:
      return action.press_type;
    default:
      return state;
  }
}

function selectedSponsorMenu(state = "", action) {
  switch (action.type) {
    case SELECT_SPONSOR_MENU:
      return action.sponsor_id;
    default:
      return state;
  }
}

function selectedNewsItem(state = "0", action) {
  switch (action.type) {
    case SELECT_NEWS_DETAIL:
      return action.news_id;
    default:
      return state;
  }
}

function movies(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_CATEGORY:
      return Object.assign({}, state, {
        didInvalidate: true
      });
    case REQUEST_MOVIES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_MOVIES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.movies,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function moviesByCategory(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_CATEGORY:
    case RECEIVE_MOVIES:
    case REQUEST_MOVIES:
      /*
      return Object.assign({}, state, {
        [action.category]: movies(state[action.category], action)
      })
      */
      const movie_list = movies(state[action.category], action);
      let moviesById = [];
      if (movie_list.items.length) {
        const nextState = movie_list.items.reduce((nextState, movie) => {
          nextState[movie.id] = movie;
          moviesById = [...moviesById, movie.id];
          return nextState;
        }, {});
        return Object.assign({}, state, {
          [action.category]: {
            isFetching: movie_list.isFetching,
            didInvalidate: movie_list.didInvalidate,
            items: nextState
          },
          moviesById: moviesById
        });
      } else {
        return state;
      }
    default:
      return state;
  }
}
/*
function moviesFestivalByCategory (state = { }, action) {
  switch (action.type) {
    case INVALIDATE_CATEGORY:
    case RECEIVE_MOVIES:
    case REQUEST_MOVIES:
      const movie_obj = movies(state[action.category], action)
      movie_obj.items = movie_obj.items.filter((movie) => {
        return movie.fromfestival === 1
      })

      return Object.assign({}, state, {
        [action.category]: movie_obj
      })
    default:
      return state
  }
}
*/
/*
function moviesById (state = { }, action) {
  switch (action.type) {
    case INVALIDATE_CATEGORY:
    case REQUEST_MOVIES:
    case RECEIVE_MOVIES:
      // return state
      if (action.movies && action.movies.length) {
        const nextState = action.movies.reduce((nextState, movie) => {
          nextState[movie.id] = movie
          return nextState
        }, {})
        return Object.assign({}, state, {
          [action.category]: nextState
        })
      } else {
        return state
      }
    default:
      return state
  }
}
*/

function movieIds(state = [], action) {
  switch (action.type) {
    case RECEIVE_MOVIES:
      return action.movies.map(movie => movie.id);
    default:
      return state;
  }
}

function byYear(state = {}, action) {
  switch (action.type) {
    case SELECT_YEAR:
    case RECEIVE_MOVIES:
      if (action.movies && action.movies.length) {
        const nextState = action.movies.reduce((nextState, movie) => {
          if (!nextState[movie.yy]) {
            nextState[movie.yy] = {};
          }
          if (
            !nextState[movie.yy]["ids"] ||
            !nextState[movie.yy]["ids"].length
          ) {
            nextState[movie.yy]["ids"] = [];
          }
          nextState[movie.yy]["ids"].push(movie.id);
          return nextState;
        }, {});
        return Object.assign({}, state, nextState);
      } else {
        return state;
      }
    default:
      return state;
  }
}

function infoMovieLite(
  state = {
    movies: []
  },
  action
) {
  switch (action.type) {
    case RECEIVE_MOVIES_BY_IDS:
      return Object.assign({}, state, {
        movies: action.movies
      });
    default:
      return state;
  }
}

function news(
  state = {
    isFetchingNews: false,
    didInvalidateNews: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_NEWS:
      return Object.assign({}, state, {
        didInvalidateNews: true
      });
    case REQUEST_NEWS:
      return Object.assign({}, state, {
        isFetchingNews: true,
        didInvalidateNews: false,
        items: []
      });
    case RECEIVE_NEWS:
      return Object.assign({}, state, {
        isFetchingNews: false,
        didInvalidateNews: false,
        items: action.news,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getAllnews(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_NEWS:
    case REQUEST_NEWS:
    case RECEIVE_NEWS:
      const news_list = news(state, action);
      const nextState = news_list.items.map((news_item, i) => {
        const month_pt = months[news_item.mm];
        const pretty_date = `${news_item.dd} ${month_pt} ${news_item.yy}`;
        return Object.assign({}, news_item, {
          pretty_date: pretty_date
        });
      }, []);

      return Object.assign({}, state, {
        all: {
          isFetchingNews: news_list.isFetchingNews,
          lastUpdated: news_list.lastUpdated,
          items: nextState
        }
      });
    default:
      return state;
  }
}

function getMoviesFromFestival(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_FESTIVAL_CITY:
    case RECEIVE_FESTIVAL_CITY:
    case REQUEST_FESTIVAL_CITY:
      const movies = festivalMovies(state[action.city], action);
      console.log('getMoviesFromFestival ----> movies', movies)
      if (Object.keys(movies.items).length) {
        selectDay(Object.keys(movies.items)[0]);
      } 

      var o = {
        [action.city]: {
          events: movies.items,
          numPastEvents: movies.numPastEvents
        }
      };

      console.log('vai ficar com: ', o);
      
      return Object.assign({}, state, {
        [action.city]: {
          events: movies.items,
          numPastEvents: movies.numPastEvents
        }
      });
    default:
      return state;
  }
}

function festivalMovies(
  state = {
    isFetchingMovieCity: false,
    didInvalidate: false,
    items: {},
    numPastEvents: 0
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_FESTIVAL_CITY:
      return Object.assign({}, state, {
        didInvalidate: true
      });
    case REQUEST_FESTIVAL_CITY:
      return Object.assign({}, state, {
        isFetchingMovieCity: true,
        didInvalidate: false
      });
    case RECEIVE_FESTIVAL_CITY:
      return Object.assign({}, state, {
        isFetchingMovieCity: false,
        didInvalidate: false,
        items: action.movies,
        numPastEvents: action.numPastEvents,
        lastUpdatedCity: action.receivedAt
      });
    default:
      return state;
  }
}

function cities(
  state = {
    isFetchingCities: false,
    didInvalidateCities: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_CITY:
      return Object.assign({}, state, {
        isFetchingCities: false,
        didInvalidateCities: true
      });
    case REQUEST_CITY:
      return Object.assign({}, state, {
        isFetchingCities: true,
        didInvalidateCities: false,
        items: []
      });
    case RECEIVE_CITY:
      return Object.assign({}, state, {
        isFetchingCities: false,
        didInvalidateCities: false,
        items: action.cities,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getAllCities(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_CITY:
    case REQUEST_CITY:
      return state;
    case RECEIVE_CITY:
      return Object.assign({}, state, {
        all: cities(state, action)
      });
    default:
      return state;
  }
}

function menus(
  state = {
    isFetchingMenus: false,
    didInvalidateMenus: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_MENUS:
      return Object.assign({}, state, {
        isFetchingMenus: false,
        didInvalidateMenus: true
      });
    case REQUEST_MENUS:
      return Object.assign({}, state, {
        isFetchingMenus: true,
        didInvalidateMenus: false,
        items: []
      });
    case RECEIVE_MENUS:
      return Object.assign({}, state, {
        isFetchingMenus: false,
        didInvalidateMenus: false,
        items: action.menus,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getMenus(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_MENUS:
    case REQUEST_MENUS:
    case RECEIVE_MENUS:
      return Object.assign({}, state, {
        // all: menus(state, action)
        [action.scope]: menus(state, action)
      });
    default:
      return state;
  }
}

function moviedetails(
  state = {
    isFetchingMDetail: false,
    didInvalidateMDetail: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_MOVIE:
      return Object.assign({}, state, {
        didInvalidateMDetail: true
      });
    case REQUEST_MOVIE:
      return Object.assign({}, state, {
        isFetchingMDetail: true,
        didInvalidateMDetail: false
      });
    case RECEIVE_MOVIE: {
      return Object.assign({}, state, {
        isFetchingMDetail: false,
        didInvalidateMDetail: false,
        items: action.details,
        lastUpdated: action.receivedAt
      });
    }
    default:
      return state;
  }
}

function getMovieDetails(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_MOVIE:
    case RECEIVE_MOVIE:
    case REQUEST_MOVIE:
      return Object.assign({}, state, {
        [action.movie_id]: moviedetails(state[action.movie_id], action)
      });
    default:
      return state;
  }
}

function activitydetails(
  state = {
    isFetchingADetail: false,
    didInvalidateADetail: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_ACTIVITY:
      return Object.assign({}, state, {
        didInvalidateADetail: true
      });
    case REQUEST_ACTIVITY:
      return Object.assign({}, state, {
        isFetchingADetail: true,
        didInvalidateADetail: false
      });
    case RECEIVE_ACTIVITY:
      return Object.assign({}, state, {
        isFetchingADetail: false,
        didInvalidateADetail: false,
        items: action.details,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getActivityDetails(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_ACTIVITY:
    case RECEIVE_ACTIVITY:
    case REQUEST_ACTIVITY:
      return Object.assign({}, state, {
        [action.activity_id]: activitydetails(state[action.activity_id], action)
      });
    default:
      return state;
  }
}

function custom_page(
  state = {
    isFetchingCPage: false,
    didInvalidateCPage: false,
    items: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_CUSTOM_PAGE:
      return Object.assign({}, state, {
        didInvalidateCPage: true
      });
    case REQUEST_CUSTOM_PAGE:
      return Object.assign({}, state, {
        isFetchingCPage: true,
        didInvalidateCPage: false
      });
    case RECEIVE_CUSTOM_PAGE:
      return Object.assign({}, state, {
        isFetchingCPage: false,
        didInvalidateCPage: false,
        items: action.details,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getCustomPage(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_CUSTOM_PAGE:
    case RECEIVE_CUSTOM_PAGE:
    case REQUEST_CUSTOM_PAGE:
      return Object.assign({}, state, {
        [action.page]: custom_page(state[action.page], action)
      });
    default:
      return state;
  }
}

function search_results(
  state = {
    isFetchingSearch: false,
    didInvalidateSearch: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_QUERY:
      return Object.assign({}, state, {
        didInvalidateSearch: true
      });
    case REQUEST_QUERY:
      return Object.assign({}, state, {
        isFetchingSearch: true,
        didInvalidateSearch: false
      });
    case RECEIVE_QUERY_RESULTS:
      return Object.assign({}, state, {
        isFetchingSearch: false,
        didInvalidateSearch: false,
        items: action.results,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getSearchResults(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_QUERY:
    case RECEIVE_QUERY_RESULTS:
    case REQUEST_QUERY:
      return Object.assign({}, state, {
        [action.query]: search_results(state[action.query], action)
      });
    default:
      return state;
  }
}

function festival_history(
  state = {
    isFetchingFestHistory: false,
    didInvalidateFestHistory: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_FEST_HISTORY:
      return Object.assign({}, state, {
        didInvalidateFestHistory: true
      });
    case REQUEST_FEST_HISTORY:
      return Object.assign({}, state, {
        isFetchingFestHistory: true,
        didInvalidateFestHistory: false,
        items: []
      });
    case RECEIVE_FEST_HISTORY:
      return Object.assign({}, state, {
        isFetchingFestHistory: false,
        didInvalidateFestHistory: false,
        items: action.fest,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getFestHistory(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_FEST_HISTORY:
    case REQUEST_FEST_HISTORY:
    case RECEIVE_FEST_HISTORY:
      return Object.assign({}, state, {
        // all: festival_history(state, action)
        [action.edition]: festival_history(state[action.edition], action)
      });
    default:
      return state;
  }
}

function sections(
  state = {
    isFetchingSections: false,
    didInvalidateSections: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_SECTIONS:
      return Object.assign({}, state, {
        isFetchingSections: false,
        didInvalidateSections: true
      });
    case REQUEST_SECTIONS:
      return Object.assign({}, state, {
        isFetchingSections: true,
        didInvalidateSections: false,
        items: []
      });
    case RECEIVE_SECTIONS:
      return Object.assign({}, state, {
        isFetchingSections: false,
        didInvalidateSections: false,
        items: action.sections,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function movs2filter(
  state = {
    isFetchingMov2Filter: false,
    didInvalidateMov2Filter: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_MOV_2_FILTER:
      return Object.assign({}, state, {
        isFetchingMov2Filter: false,
        didInvalidateMov2Filter: true
      });
    case REQUEST_MOV_2_FILTER:
      return Object.assign({}, state, {
        isFetchingMov2Filter: true,
        didInvalidateMov2Filter: false,
        items: []
      });
    case RECEIVE_MOV_2_FILTER:
      return Object.assign({}, state, {
        isFetchingMov2Filter: false,
        didInvalidateMov2Filter: false,
        items: action.movs,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getSections(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_SECTIONS:
    case REQUEST_SECTIONS:
    case RECEIVE_SECTIONS:
      return Object.assign({}, state, {
        // all: sections(state, action)
        [`${action.assetType}_${action.scope}`]: sections(state, action)
      });
    default:
      return state;
  }
}

function getMovs2Filter(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_MOV_2_FILTER:
    case REQUEST_MOV_2_FILTER:
    case RECEIVE_MOV_2_FILTER:
      return Object.assign({}, state, {
        all: movs2filter(state, action)
      });
    default:
      return state;
  }
}

function activities(
  state = {
    isFetchingActivities: false,
    didInvalidateActivities: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_ACTIVITIES:
      return Object.assign({}, state, {
        isFetchingActivities: false,
        didInvalidateActivities: true
      });
    case REQUEST_ACTIVITIES:
      return Object.assign({}, state, {
        isFetchingActivities: true,
        didInvalidateActivities: false,
        items: []
      });
    case RECEIVE_ACTIVITIES:
      return Object.assign({}, state, {
        isFetchingActivities: false,
        didInvalidateActivities: false,
        items: action.activities,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getActivities(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_ACTIVITIES:
    case REQUEST_ACTIVITIES:
      return state;
    case RECEIVE_ACTIVITIES:
      return Object.assign({}, state, {
        all: activities(state, action)
      });
    default:
      return state;
  }
}

function press(
  state = {
    isFetchingPress: false,
    didInvalidatePress: false,
    items: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_PRESS:
      return Object.assign({}, state, {
        didInvalidatePress: true
      });
    case REQUEST_PRESS:
      return Object.assign({}, state, {
        isFetchingPress: true,
        didInvalidatePress: false
      });
    case RECEIVE_PRESS:
      return Object.assign({}, state, {
        isFetchingPress: false,
        didInvalidatePress: false,
        items: action.press,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getPress(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_PRESS:
    case RECEIVE_PRESS:
    case REQUEST_PRESS:
      if (
        typeof action.press_type === "undefined" ||
        action.press_type === ""
      ) {
        return state;
      }

      return Object.assign({}, state, {
        [action.press_type]: press(state[action.press_type], action)
      });
    default:
      return state;
  }
}

function sponsors(
  state = {
    isFetchingSpMenu: false,
    didInvalidateSpMenu: false,
    items: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_SPONSOR_MENU:
      return Object.assign({}, state, {
        didInvalidateSpMenu: true
      });
    case REQUEST_SPONSOR_MENU:
      return Object.assign({}, state, {
        isFetchingSpMenu: true,
        didInvalidateSpMenu: false
      });
    case RECEIVE_SPONSOR_MENU:
      return Object.assign({}, state, {
        isFetchingSpMenu: false,
        didInvalidatePress: false,
        items: action.sponsor,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getSponsorMenu(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_SPONSOR_MENU:
    case RECEIVE_SPONSOR_MENU:
    case REQUEST_SPONSOR_MENU:
      if (
        typeof action.sponsor_id === "undefined" ||
        action.sponsor_id === ""
      ) {
        return state;
      }

      const k = action.scope + "_" + action.sponsor_id;
      return Object.assign({}, state, {
        [k]: sponsors(state[action.sponsor_id], action)
      });
    default:
      return state;
  }
}

function homesponsors(
  state = {
    isFetchingSpHome: false,
    didInvalidateSpHome: false,
    items: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_SPONSOR_HOME:
      return Object.assign({}, state, {
        didInvalidateSpHome: true
      });
    case REQUEST_SPONSOR_HOME:
      return Object.assign({}, state, {
        isFetchingSpHome: true,
        didInvalidateSpHome: false
      });
    case RECEIVE_SPONSOR_HOME:
      return Object.assign({}, state, {
        isFetchingSpHome: false,
        didInvalidateSpHome: false,
        items: action.sponsors,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

/*
function getSponsorHome (state = { }, action) {
  switch (action.type) {
    case INVALIDATE_SPONSOR_HOME:
    case RECEIVE_SPONSOR_HOME:
    case REQUEST_SPONSOR_HOME:
    // aqui
      const sponsor_list = homesponsors(state, action)
      if (sponsor_list.hasOwnProperty('items') && sponsor_list.items.length) {
        const nextState = sponsor_list.items.reduce((nextState, sp) => {
          if (!nextState[sp.area]) {
            nextState[sp.area] = []
          }

          if (sp.area === 'default') {
            if (!nextState[sp.area][sp.name]) {
              nextState[sp.area][sp.name] = []
            }
            nextState[sp.area][sp.name].push(sp)
          } else {
            nextState[sp.area].push(sp)
          }

          return nextState
        }, {})
        return Object.assign({}, state, {
          ['all']: {
            isFetchingSpHome: sponsor_list.isFetchingSpHome,
            didInvalidateSpHome: sponsor_list.didInvalidateSpHome,
            items: nextState
          }
        })
      } else {
        return state
      }
    default:
      return state
  }
}
*/

function getSponsorHome(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_SPONSOR_HOME:
    case RECEIVE_SPONSOR_HOME:
    case REQUEST_SPONSOR_HOME:
      // aqui
      const sponsor_list = homesponsors(state, action);
      if (sponsor_list.hasOwnProperty("items") && sponsor_list.items.length) {
        let sponsorIds = [];
        const nextState = sponsor_list.items.reduce((nextState, sp) => {
          if (!nextState[sp.name]) {
            nextState[sp.name] = [];
            sponsorIds = [...sponsorIds, sp.name];
          }
          nextState[sp.name].push(sp);

          return nextState;
        }, {});
        return Object.assign({}, state, {
          ["all"]: {
            isFetchingSpHome: sponsor_list.isFetchingSpHome,
            didInvalidateSpHome: sponsor_list.didInvalidateSpHome,
            items: nextState,
            ids: sponsorIds
          }
        });
      } else {
        return state;
      }
    default:
      return state;
  }
}

function allposters(
  state = {
    isFetchingPosters: false,
    didInvalidatePosters: false,
    items: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_POSTER:
      return Object.assign({}, state, {
        didInvalidatePosters: true
      });
    case REQUEST_POSTER:
      return Object.assign({}, state, {
        isFetchingPosters: true,
        didInvalidatePosters: false
      });
    case RECEIVE_POSTER:
      return Object.assign({}, state, {
        isFetchingPosters: false,
        didInvalidatePosters: false,
        items: action.posters,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getPosters(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_POSTER:
    case RECEIVE_POSTER:
    case REQUEST_POSTER:
      return Object.assign({}, state, {
        [action.scope]: allposters(state, action)
      });
    default:
      return state;
  }
}

function newsdetails(
  state = {
    isFetchingNDetail: false,
    didInvalidateNDetail: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_NEWS_DETAIL:
      return Object.assign({}, state, {
        didInvalidateNDetail: true
      });
    case REQUEST_NEWS_DETAIL:
      return Object.assign({}, state, {
        isFetchingNDetail: true,
        didInvalidateNDetail: false
      });
    case RECEIVE_NEWS_DETAIL:
      return Object.assign({}, state, {
        isFetchingNDetail: false,
        didInvalidateNDetail: false,
        items: action.details,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getNewsDetails(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_NEWS_DETAIL:
    case RECEIVE_NEWS_DETAIL:
    case REQUEST_NEWS_DETAIL:
      return Object.assign({}, state, {
        [action.news_id]: newsdetails(state[action.news_id], action)
      });
    default:
      return state;
  }
}

function tickets(
  state = {
    isFetchingTicket: false,
    didInvalidateTicket: false,
    items: {}
  },
  action
) {
  switch (action.type) {
    case REQUEST_TICKET:
      return Object.assign({}, state, {
        isFetchingTicket: true,
        didInvalidateTicket: false
      });
    case RECEIVE_TICKET:
      return Object.assign({}, state, {
        isFetchingTicket: false,
        didInvalidateTicket: false,
        items: action.resp,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getTickets(state = {}, action) {
  switch (action.type) {
    case RECEIVE_TICKET:
    case REQUEST_TICKET:
      return Object.assign({}, state, {
        ticket: tickets(state, action)
      });
    default:
      return state;
  }
}

function onChangeNewsLetterStatus(
  state = {
    isFetchingNewsLetter: false,
    didInvalidateNewsLetter: false,
    items: {}
  },
  action
) {
  switch (action.type) {
    case REQUEST_NEWSLETTER:
      return Object.assign({}, state, {
        isFetchingNewsLetter: true,
        didInvalidateNewsLetter: false
      });
    case RECEIVE_NEWSLETTER_ACK:
      return Object.assign({}, state, {
        isFetchingNewsLetter: false,
        didInvalidateNewsLetter: false,
        items: action.resp,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getNewsLetterState(state = {}, action) {
  switch (action.type) {
    case RECEIVE_NEWSLETTER_ACK:
    case REQUEST_NEWSLETTER:
      return Object.assign({}, state, {
        nletterState: onChangeNewsLetterStatus(state, action)
      });
    default:
      return state;
  }
}

function festprogs(
  state = {
    isFetchingFestProg: false,
    didInvalidateFestProg: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case REQUEST_FEST_PROG:
      return Object.assign({}, state, {
        isFetchingFestProg: true,
        didInvalidateFestProg: false
      });
    case RECEIVE_FEST_PROG:
      return Object.assign({}, state, {
        isFetchingFestProg: false,
        didInvalidateFestProg: false,
        items: action.festprogram,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

function getFestProg(state = {}, action) {
  switch (action.type) {
    case RECEIVE_FEST_PROG:
    case REQUEST_FEST_PROG:
      return Object.assign({}, state, {
        all: festprogs(state, action)
      });
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  moviesByCategory,
  selectedCustomPage,
  showNewsLetterFrom,
  getCustomPage,
  getMenus,
  selectedCategory,
  selectedScope,
  selectedAgendaColor,
  selectedVisibility,
  selectedYear,
  selectedDay,
  // moviesById,
  movieIds,
  byYear,
  // moviesFestivalByCategory,
  infoMovieLite,
  getAllnews,
  selectedCity,
  getMoviesFromFestival,
  getAllCities,
  selectedMovie,
  getMovieDetails,
  selectedPlayVideo,
  selectedActivity,
  getActivityDetails,
  selectedSearchQuery,
  getSearchResults,
  selectedFestHistory,
  getFestHistory,
  selectedFestHistorySubPage,
  selectedSection,
  selectedMov2Filter,
  getSections,
  getMovs2Filter,
  selectedAZ,
  getActivities,
  selectedPress,
  getPress,
  getSponsorMenu,
  selectedSponsorMenu,
  getSponsorHome,
  getPosters,
  selectedNewsItem,
  getNewsDetails,
  getTickets,
  onChangeNewsLetterStatus,
  getNewsLetterState,
  getFestProg,
  form: formReducer,
  router
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers.js